<template>
  <b-overlay
    :show="isLoading"
    spinner-variant="secondary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card class="card h-100 bordered mb-3" :class="{ shadowed: !isLocked }">
      <div class="card-content d-flex justify-content-between flex-column">
        <div class="d-flex justify-content-between" @click="!isLocked ? $emit('onCta') : null">
          <div class="d-flex align-items-center" :class="{ locked: isLocked }">
            <div class="icon align-self-start">
              <img :src="icon" alt="..." class="icon" />
            </div>
            <div class="pl-3">
              <small class="text-bold">{{ type }}</small>
              <p class="h6 mb-0">{{ title }}</p>
              <p class="mb-0" v-if="description">{{ description }}</p>
              <div class="d-sm-flex mt-1" v-if="options">
                <div v-for="(option, index) in options" :key="index" class="pr-3">
                  <div v-if="option.icon">
                    <img :src="option.icon.url" width="24" height="24" class="align-self-center" />
                    <small>{{ option.label }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-end buttons-wrapper">
          <b-button
            v-if="isLocked"
            variant="light"
            class="align-self-end pr-3 pl-2 d-flex"
            pill
            size="sm"
            @click="$emit('showToast')"
          >
            <img
              src="/images/master-dashboard/ic_lock.svg"
              width="16"
              class="align-self-center mx-1"
            />
            {{ trans("streams.dashboard.week") }}
            {{ weekNumber }}
          </b-button>
          <b-button
            v-else-if="completed"
            variant="success"
            class="align-self-end pr-3 pl-2 d-flex"
            pill
            size="sm"
            @click="$emit('onCta')"
          >
            <b-icon-check2 font-scale="1.5" shift-v="-1" class="pr-1" />
            {{ trans("streams.dashboard.week") }}
            {{ weekNumber }}
          </b-button>
          <slot v-else />
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    icon: String,
    type: String,
    title: String,
    description: String,
    completed: Boolean,
    options: Array,
    route: String | Object,
    isLocked: Boolean,
    weekNumber: Number,
    isLoading: Boolean,
  },
};
</script>

<style scoped lang="scss">
.card {
  cursor: pointer;
  border-radius: 0.5rem;
}
.card-body {
  padding: 0;
}
.card-content {
  padding: 1.4rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.link-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.buttons-wrapper {
  position: relative;
  z-index: 1;
}
.locked {
  opacity: 0.5;
}
</style>
